<template>
    <el-dialog title="详情" :visible.sync="dialogVisible">
        <div class="commentDesp">
            <div class="ash_bg_box">
                <div class="name">
                    <div class="left">内容名称：</div>
                    <div class="right">{{data.assetname}}</div>
                </div>
                <div class="desp">
                    <div class="left">内容详情：</div>
                    <div class="right" @click="checkContentDesp">查看内容详情</div>
                </div>
            </div>
            <div class="comment_content" ref="commentContent">
                <div :class="{'user_comment': true, 'border_b': data.replylist && data.replylist.length}">
                    <div class="img"><img :src="data.headimageurl" alt=""></div>
                    <div class="content">
                        <div class="name_date">
                            <div class="name">{{data.customername}}</div>
                            <div class="date">{{data.datetime}}</div>
                        </div>
                        <div class="comment">{{data.content}}</div>
                    </div>
                </div>
                <div class="reply" v-for="(item, index) in data.replylist" :key="index" :id="'reply'+index">
                    <div class="img"><img :src="item.headimageurl" alt=""></div>
                    <div class="content">
                        <div class="name">
                            <span class="master">{{item.customername}}</span>
                            回复
                            <span class="user">{{data.customername}}</span>
                        </div>
                        <div class="comment">{{item.replycontent}}</div>
                    </div>
                </div>
            </div>
            <div class="inputBox">
                <el-input v-model="replyData" placeholder="请输入你要回复的内容"></el-input>
                <el-button @click="uploadReplyCommentInfo">回复</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {findCommentDetail, uploadReplyCommentInfo} from 'api/activeApi.js'
import { mapActions, mapGetters} from 'vuex' // 引入 vuex 组件
export default {
    name: 'commentDesp',
    data() {
        return {
            dialogVisible: false,
            data: {},
            replyData: '',
            comment: ''
        }
    },
    methods: {
        open(row) {
            this.findCommentDetail(row)
            this.comment = row
        },

        // 评论详情
        findCommentDetail(row) {
            let options = {
                innerid: row.innerid
            }
            this.setLoading(true)
            findCommentDetail({
                data: options,
                success: res => {
                    this.setLoading(false)
                    this.data = res.data
                    this.dialogVisible = true
                    console.log(res)
                },
                error: res =>{
                    this.$message.error(res.msg)
                    this.setLoading(false)
                }
            })
        },
        uploadReplyCommentInfo() {
            if (this.replyData) {
                this.setLoading(true)
                let options = {
                    innerid: this.comment.innerid,
                    content: this.replyData
                }
                uploadReplyCommentInfo({
                    data: options,
                    success: res => {
                        this.setLoading(false)
                        let obj = {
                            replycontent: this.replyData,
                            headimageurl: this.user.logourl,
                            customername: this.user.nickname
                        }
                        this.data.replylist.push(obj)
                        this.replyData = ''
                        this.$nextTick(() => {
                            let top = 0
                            this.data.replylist.forEach((obj, index) => {
                                let reply = document.querySelector(`#reply${index}`)
                                top += reply.offsetHeight
                            })
                            this.$refs.commentContent.scrollTop = top + 344
                        })
                    },
                    error: res => {
                        this.$message.error(res.msg)
                        this.setLoading(false)
                    }
                })
            } else {
                this.$message.error('请输入回复的内容')
            }
        },
        // 查看内容详情
        checkContentDesp() {
            window.open(this.data.detailurl)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    }
}
</script>
<style lang="scss">
    .el-dialog {
        .el-dialog__body {
            padding: 0;
            .commentDesp {
                .ash_bg_box {
                    background: #F5F7FA;
                    padding: 0 20px 20px;
                    .name, .desp {
                        display: flex;
                        align-items: center;
                        padding: 20px 0 0;
                        .left {
                            font-size: 14px;
                            margin-right: 34px;
                        }
                        .right {
                            color: #606266;
                            font-size: 14px;
                        }
                    }
                    .desp {
                        .right {
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                }
                .comment_content {
                    padding: 20px 20px;
                    max-height: 344px;
                    box-sizing: border-box;
                    overflow-y: scroll;
                    .user_comment {
                        display: flex;
                        padding-bottom: 16px;
                        margin-bottom: 20px;
                        .img {
                            width: 50px;
                            height: 50px;
                            margin-right: 8px;
                            img {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                            }
                        }
                        .content {
                            .name_date {
                                display: flex;
                                align-items: center;
                                margin-bottom: 10px;
                                .name {
                                    font-size: 16px;
                                    margin-right: 10px;
                                }
                                .date {
                                    font-size: 14px;
                                    color: #C0C4CC;
                                }
                            }
                            .comment {
                                font-size: 14px;
                                color: #909399;
                                line-height: 21px;
                            }
                        }
                    }
                    .border_b {
                        border-bottom: 1px solid #DCDFE6;
                    }
                    .reply {
                        display: flex;
                        padding-left: 58px;
                        margin-bottom: 20px;
                        .img {
                            width: 30px;
                            height: 30px;
                            margin-right: 10px;
                            img {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                            }
                        }
                        .content {
                            .name {
                                font-size: 14px;
                                .master {
                                    color: #409EFF;
                                    margin-right: 10px;
                                }
                                .user {
                                    color: #409EFF;
                                    margin-left: 10px;
                                }
                            }
                            .comment {
                                font-size: 14px;
                                color: #909399;
                                line-height: 20px;
                                margin-top: 10px;
                            }
                        }
                    }
                }
                .inputBox {
                    display: flex;
                    padding: 20px 20px 0;
                    .el-input {
                        margin-right: 10px;
                        height: 40px;
                        .el-input__inner {
                            height:40px;
                            line-height: 40px;
                        }
                    }
                    .el-button {
                        width: 80px;
                        height: 40px;
                        background: #1464C8;
                        color: #fff;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    
</style>